import React from 'react'

const WhatWeDo = ({ data }) => {
  return (
    <div>
      <section className="py-5 overflow-hidden">
        <div className="container">
          <h1 className="text-center what-head mb-5">What We Do?</h1>

      
          <div className="container my-5">
            <div className="row gx-5 gy-5 ">
              {data.map((item, index) => (
                <div key={item.id} className="col-md-6 mb-4">
                  <div className="d-flex flex-column flex-md-row gapwhatwe whatwedoalign">
                    {/* Image block */}
                    <div className="icon-wrapper position-relative text-center me-2 text-md-start">
                      <div className="icon-circle">
                        <img
                          src={item.img}
                          alt={`Icon ${index + 1}`}
                          className="icon-image"
                        />
                      </div>
                      <div className="index-badge">{index + 1}</div>
                    </div>

                    {/* Content block */}
                    <div>
                      <h6
                        className="strong"
                        dangerouslySetInnerHTML={{ __html: item.title }}
                      ></h6>
                      <ul className="whatcontentfont">
                        {item.points.map((point, idx) => (
                          <li key={idx} dangerouslySetInnerHTML={{ __html: point }} />
                        ))}
                      </ul>
                    </div>
                  </div>
                </div>

              ))}
            </div>
          </div>




        </div>
      </section>

    </div>
  )
}

export default WhatWeDo
